import { Component, OnInit } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { AssessmentService } from "../../services/assessment.service";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { CourseService } from '../../services/course.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-course-add-modules',
  templateUrl: './course-add-modules.component.html',
  styleUrls: ['./course-add-modules.component.scss']
})
export class CourseAddModulesComponent implements OnInit {
  closeResult = ''; subModError: any = 1; countModule: any = []; moduleId: any = ''; increment: any = 0;
  courseId: any = ''; adminData: any; courseModuelAuthForm: any; indexSub: any; moveToAddCapsule: boolean = false; moveToViewCapsule:boolean = false;
  submitted = false; tab: any; errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' };
  moveToAddModule: boolean = false; tempStoreFormData: any = null; tempStoreFormDataBlank:any= null; assessment_id: any = null; capsule_id: any = null;
  status: any; indexSubModule: any = ''; capsuleAssign: any = []; capsuleAssignData: any = [];capsuleData_id:any=null;
  DeleteModuleId: any = ''; IndModule: any = ''; page: string = 'create';type:any='';pro:any='';modId:any='';
  selectModuleId:any='';
  constructor(private _fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private contentAuthoringApi: ContentAuthoringService,
    private AssessmentServiceApi: AssessmentService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal, private toastr: ToastrService, private authCourse: CourseService) {
  }
  //courseModuelAuthForm = new FormGroup({});
  get f() { return this.courseModuelAuthForm.controls; }
  get formArr() {
    return this.courseModuelAuthForm.get('subModules') as FormArray;
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  logout() {
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  opens(content: any, ModulesId: any, index: any) {
    if (ModulesId != ''){
      this.DeleteModuleId = ModulesId;
      this.IndModule = index;
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }else{

       // this.DeleteModuleId = this.countModule[this.countModule.length-2]['id'];
        this.DeleteModuleId = '';
        this.IndModule = index;
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
     
     
    }
     
  }
  /******delete assesment */
  deleteAssessment(assessment_id: any) {
    this.AssessmentServiceApi.dltassessment(assessment_id, this.capsule_id).subscribe(
      data => {
        if (data.status = 200) {
          document.getElementById('CloseIds')?.click();
          this.assessment_id = '';
        }
      }, error => {
        alert(error);
      });
  }
  /**********form controles of sun modules  */
  initSubModule() {
    return this._fb.group({
      submodule_name: [null, [Validators.required]],
      submodule_desc: [null, [Validators.required]],
      submodule_num: [null],
      content_capsule_id: [null],
      is_active: [0],
      course_id: [this.courseId],
      module_id: [null],
      submodule_id: [null]
    });
  }
  /*******add sub modules */
  addNewSubModule() {
    this.formArr.push(this.initSubModule());
  }
  /********delete sub module function  */
  deleteSubModule(index: number) {
    this.formArr.removeAt(index);
    this.capsuleAssign.splice(index, 1);
    this.capsuleAssignData.splice(index, 1);
  }
  /********delete selected capsule function */
  deleteCapsule(index: number) {
    
    this.capsuleAssign[index]='';
    this.capsuleAssignData[index]='';
  }
AutoSave(){
  this.createCourseAddModules(1,1)
}
  /*****************create course *********/
  createCourseAddModules(tab: any, status: any) {
    this.selectModuleId='';
    if (this.courseModuelAuthForm.get('subModules').length == 0) { this.subModError = 1; } else { this.subModError = 0; };
    this.status = status;
    this.tab = tab;
    this.submitted = true;
    if ((this.courseModuelAuthForm.valid && status == 0) || (this.courseModuelAuthForm.valid && this.subModError == 0 &&
      status == 1 && this.capsuleAssign.length == this.courseModuelAuthForm.get('subModules').length && this.assessment_id != ''
      && this.assessment_id != null)) {
      let formValue = this.courseModuelAuthForm.value;
      this.spinner.show();
      formValue['is_active'] = status; formValue['course_id'] = this.courseId; formValue['assessment_id'] = this.assessment_id;
      let qts = formValue.subModules;
      for (let n = 0; n < qts.length; n++) { qts[n]['submodule_num'] = n + 1; }
      formValue['subModules'] = qts;
      if (!this.courseModuelAuthForm.value.module_id) { this.page = 'create'; } else { this.page = 'edit'; }
      this.authCourse.creatModule(formValue, this.page).subscribe(
        data => {
          if (data.status == 201 || data.status == 200) {
            if (this.countModule.some(function (el: any) { return el.id === data.module_id }) != true) {
              if(this.type || this.pro){
                this.countModule.splice((this.countModule.length) - 1, 0, { 'id': data.module_id });
              }else{
                this.countModule.splice((this.countModule.length) - 1, 0, { 'id': data.module_id });
              }
            }else{
              if(this.countModule[this.countModule.length-1]['id'] !=''){
                this.countModule.push({ 'id': '' });
              }
            }
            this.capsuleAssignData = []; this.capsuleAssign = []; this.assessment_id = '';
            this.formArr.reset();
            while (this.formArr.length !== 0) { this.formArr.removeAt(0) }
            this.submitted = false;
            this.courseModuelAuthForm.reset();
            if (this.tab == 2) {
              this.router.navigate(['/courses'], { queryParams: { tab: this.tab } });
            } else if (this.tab == 3 && this.type =='edit') { this.router.navigate(['/courses_add_review'], { queryParams: { courseId: this.courseId,type:'edit' } });
            }else if (this.tab == 3) {this.router.navigate(['/courses_add_review'], { queryParams: { courseId: this.courseId } });}
            this.spinner.hide();
          } else { this.spinner.hide(); }
        }, error => { this.spinner.hide(); }
      );
    } else {
      for (const i in this.courseModuelAuthForm.controls) {
        if (this.courseModuelAuthForm.controls.hasOwnProperty(i)) {
          this.courseModuelAuthForm.controls[i].markAsDirty();
          this.courseModuelAuthForm.controls[i].updateValueAndValidity();
        }
      }
      for (const i in (this.formArr).controls) {
        if ((this.formArr).controls.hasOwnProperty(i)) {
          for (const j in (<FormArray>(this.formArr).controls[i]).controls) {
            if ((<FormArray>(this.formArr).controls[i]).controls.hasOwnProperty(j)) {
              (<FormArray>(this.formArr).controls[i]).controls[j].markAsDirty();
              (<FormArray>(this.formArr).controls[i]).controls[j].updateValueAndValidity();
            }
          }
        }
      }
    }
  }
  /*****get courses module ID */
  // getModulesID(courseId: any) {
  //   this.authCourse.getModules(courseId).subscribe(
  //     data => {
  //       if (data.modules) {
  //         let arr: Array<any> = data.modules;
  //         arr.forEach(element => {
  //           if(this.type || this.pro){
  //             this.countModule.push({ 'id': element });  
  //           }else{
  //             this.countModule.splice((this.countModule.length) - 1, 0, { 'id': element });
  //           }
  //         });
  //         if(this.type || (this.pro && !this.modId)){
  //         this.getModuleDetails(this.countModule[this.countModule.length-1]['id'], '');
  //         }else if(this.modId && this.pro){
  //           this.getModuleDetails(this.modId,'');
  //         }
  //       }
  //     }, error => {
  //     });
  // }
  getModulesID(courseId: any) {
    this.authCourse.getModules(courseId).subscribe(
      data => {
        if(data.modules.length==0){
          this.countModule.push({ 'id': '' });
        }
        if (data.modules) {
          let arr: Array<any> = data.modules;
          arr.forEach(element => {
            if(this.type || this.pro){  this.countModule.push({ 'id': element });  
            }else{ this.countModule.splice((this.countModule.length), 0, { 'id': element });  }
          });

          if(this.courseId != '' && this.courseId != null && !this.type && !this.pro && !this.modId){
          
            this.getModuleDetails(this.countModule[this.countModule.length-1]['id'], '');
          }

          if(this.type || (this.pro && !this.modId)){
           
            this.getModuleDetails(this.countModule[this.countModule.length-1]['id'], '');
          }else if(this.modId && this.pro){
           
            this.getModuleDetails(this.modId,'');
          }
        }
      }, error => {
      });
  }
  /****get courses modules details */
  getModuleDetails(moduleId: any, index: any) {
    this.selectModuleId=moduleId;
    if ((this.courseModuelAuthForm.value.course_id == '' || this.courseModuelAuthForm.value.course_id == null) && this.courseModuelAuthForm.value.module_id) {
      this.tempStoreFormData = this.courseModuelAuthForm.value;
     
    }else if((this.courseModuelAuthForm.value.course_id == '' || this.courseModuelAuthForm.value.course_id == null) && !this.courseModuelAuthForm.value.module_id){
      this.tempStoreFormDataBlank = this.courseModuelAuthForm.value;
     
    }
    if (moduleId != '' && moduleId != null) {
     
      this.spinner.show();
     
      this.capsuleAssignData = []; this.capsuleAssign = []; this.assessment_id = ''; this.increment = 0; this.formArr.reset();
      while (this.formArr.length !== 0) { this.formArr.removeAt(0) }
      this.submitted = false;
      this.courseModuelAuthForm.reset();
      this.authCourse.getModulesDetail(moduleId).subscribe(
        data => {
          if (data.module_data && data.module_data.subModules) {
            let arr: Array<any> = data.module_data.subModules;
            arr.forEach((element,i)=> {
              this.addNewSubModule();
              setTimeout(() => {
              if (element.content_capsule_id != '' && element.content_capsule_id != null) {
                this.contentAuthoringApi.getContentAuthDetails(element.content_capsule_id).subscribe(
                  (data) => {
                    this.capsuleAssignData[this.increment] = data.data
                    this.capsuleAssign[this.increment] = data.data.content_capsule_id
                    this.increment++;
                    this.spinner.hide();
                  }, error => {
                    this.spinner.hide();
                  });
              }
            }
            , i * 500);
              this.spinner.hide();
              //wait(1000);
            });
            this.courseModuelAuthForm.patchValue(data.module_data);
            this.assessment_id = data.module_data.assessment_id;
          } else {
            this.spinner.hide();
          }
        }, error => {
          this.spinner.hide();
        });
      this.spinner.hide();
    } else {
     
      //this.spinner.show();
      this.capsuleAssignData = [];
      this.capsuleAssign = [];
      this.assessment_id = '';
      this.formArr.reset();
      this.increment = 0;
      while (this.formArr.length !== 0) { this.formArr.removeAt(0) }
      this.submitted = false;
      this.courseModuelAuthForm.reset();
      if (this.tempStoreFormDataBlank && this.tempStoreFormDataBlank.subModules) {
        let arr: Array<any> = this.tempStoreFormDataBlank.subModules;
        arr.forEach(element => {
          if (element.content_capsule_id != '' && element.content_capsule_id != null) {
            this.contentAuthoringApi.getContentAuthDetails(element.content_capsule_id).subscribe(
              (data) => {
                this.capsuleAssignData[this.increment] = data.data;
                this.capsuleAssign[this.increment] = this.capsule_id;
                this.increment++;
              }, error => {
                //this.spinner.hide();
              });
          }
          // this.spinner.hide();
          this.addNewSubModule();
        });
       
        this.courseModuelAuthForm.patchValue(this.tempStoreFormDataBlank);
        if (this.tempStoreFormDataBlank != '' && this.tempStoreFormDataBlank != null) {
          this.assessment_id = this.tempStoreFormDataBlank.assessment_id;
        }
      } else {
        // this.spinner.hide();
      }
    }
  }
  /*****delete module sub module of course ***/
  deletesModules(moduleId: any, index: any) {
    if (moduleId != '' && moduleId != null) {
      this.authCourse.deletesModules(moduleId).subscribe(
        data => {
          document.getElementById('CloseIds')?.click();
          this.countModule.splice(index, 1);
          this.getModuleDetails(this.countModule[this.countModule.length-1]['id'], index);
        }, error => {
        });
    }else{
      document.getElementById('CloseIds')?.click();
      this.countModule.splice(index, 1);
      this.getModuleDetails(moduleId, index);

    }
  }
  addAssesment() {
    this.tempStoreFormData = this.courseModuelAuthForm.value;
    this.courseModuelAuthForm.reset();
    this.moveToAddModule = true;
  }
  addCapsule(index: any) {
    this.indexSubModule = index;
    this.tempStoreFormData = this.courseModuelAuthForm.value;
    this.courseModuelAuthForm.reset();
    this.moveToAddModule = true;
    this.moveToAddCapsule = true;
  }
  retFromAddAss(evt: any) {
    this.spinner.show();
    //this.assessment_id = '';
    this.moveToAddModule = false;
    if (evt.status == true) {
      this.assessment_id = evt.assessment_id;
      this.tempStoreFormData['assessment_id'] = this.assessment_id;
    }
    setTimeout(() => {
      // if(this.tempStoreFormData.module_id){
       
      //   this.courseModuelAuthForm.patchValue(this.tempStoreFormData);
      //   this.getModuleDetails(this.tempStoreFormData.module_id,'');
      // }else{
        
      //   this.getModuleDetails('','');
      // }
    
      //console.log(this.tempStoreFormData,'assessmnetId-after');
      this.courseModuelAuthForm.patchValue(this.tempStoreFormData);
      this.spinner.hide();
    }, 1000);
  }
  retFromAddCap(evt: any) {
    this.capsule_id = '';
    if (evt.status == true) {
      this.spinner.show();
      setTimeout(() => {
        this.capsule_id = evt.capsule_id;
        this.contentAuthoringApi.getContentAuthDetails(this.capsule_id).subscribe(
          (data) => {
            console.log(data);
            if (data.status == 200) {
              this.moveToAddModule = false;
              this.moveToAddCapsule = false;
              this.capsuleAssignData[this.indexSubModule] = data.data
              this.capsuleAssign[this.indexSubModule] = this.capsule_id
              this.tempStoreFormData.subModules[this.indexSubModule]['content_capsule_id'] = this.capsule_id;
              this.courseModuelAuthForm.patchValue(this.tempStoreFormData);
              this.spinner.hide();
            }
          }, error => {
            this.spinner.hide();
            alert('error');
          });
        this.spinner.hide();
      }, 5000);
    } else {
      this.moveToAddModule = false;
      this.moveToAddCapsule = false;
      this.courseModuelAuthForm.patchValue(this.tempStoreFormData);
      this.spinner.hide();
    }
    console.log(this.tempStoreFormData);
  }
  /**** come back from view capsule *******/
  backFromCapsule(evt: any){
    this.moveToAddModule = false;
    this.moveToViewCapsule = false;
    this.courseModuelAuthForm.patchValue(this.tempStoreFormData);
  }
  /******* function for view capsule *****/
  viewCapsule(capsulesId:any){
    this.capsuleData_id = capsulesId;
    this.tempStoreFormData = this.courseModuelAuthForm.value;
    this.courseModuelAuthForm.reset();
    this.moveToViewCapsule = true;
    this.moveToAddModule = true;
  }
  getMediaType(mediatypeArr: any, media_type: any) {
    const checkMediType = (obj: { media_type: string; }) => obj.media_type == media_type;
    return mediatypeArr.some(checkMediType);
  }
  editAssesment() {
    console.log('editAssesment');
    this.tempStoreFormData = this.courseModuelAuthForm.value;
    //console.log(this.tempStoreFormData);
    this.courseModuelAuthForm.reset();
    if (this.assessment_id) {
      this.moveToAddModule = true;
    }
  }
  
  cancelbkCourse() {
    document.getElementById('CloseIds')?.click();
    if(this.type == 'edit'){ this.router.navigate(['/courses_create'], { queryParams: { Id: this.courseId,type:'edit' } });
    }else if(this.pro == 'review'){  this.router.navigate(['/courses_create'], { queryParams: { Id: this.courseId,pro:'review' } });
    }else{  this.router.navigate(['/courses_create'], { queryParams: { Id: this.courseId} });}
    
      }
  cancelCourse() {
    if(this.type =='edit'){
      document.getElementById('CloseIds')?.click();
      this.router.navigate(['/courses']);
    }else{
      this.authCourse.deletesCourse(this.courseId).subscribe(
        (data) => {
          if (data.status == 200) {
            document.getElementById('CloseIds')?.click();
            this.router.navigate(['/courses']);
          } else {
          }
        },
        (error) => {
        },
      );
    }
    
  }
  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.courseId = queryParams['courseId'];
      this.type = queryParams['type'];
      this.pro = queryParams['pro'];
      this.modId = queryParams['ModId'];
    });
    // if(!this.type && !this.pro){
    //   this.countModule.push({ 'id': '' });
    // }
    
    if (this.courseId != '' && this.courseId != null) {
      this.getModulesID(this.courseId);
    }
    this.courseModuelAuthForm = this._fb.group({
      course_id: [''],
      module_id: [''],
      module_num: [''],
      module_name: ['', [Validators.required]],
      module_desc: ['', [Validators.required]],
      is_active: [''],
      assessment_id: [''],
      created_by: [this.adminData.user_id],
      subModules: this._fb.array([]) //this.initItemMore()
    });
  }
}

